import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getOnlineDotProps } from 'utils'

class ChatTitle extends Component {
    constructor(props){
        super(props);

        this.state = {
            name: ''
        }
    }

    UNSAFE_componentWillUpdate = (nextProps) => {
        if(!this.props.isNameBeingEdited && nextProps.isNameBeingEdited){
            setTimeout(_ => {
                this.refs.nameInput.focus();
            },10);
        }else if(this.props.isNameBeingEdited && !nextProps.isNameBeingEdited){
            this.props.handleChatNameChange('')
        }
    }

    updateName = e => {
        this.props.handleChatNameChange(e.target.value)
    }

    saveChatTitle = _ => {
        this.props.saveChatTitle()
    }

    render(){
        const {
            chat,
            isSingle,
            allUsers,
            userId,
            onlineUsers,
            tempChatTitle,
            isNameBeingEdited,
            allTeams,
            optimistic
        } = this.props

        if(!chat){
            return
        }

        let name, users, isNew

        if(!optimistic && chat){
            name = chat.name
            users = chat.userIds ? chat.userIds : []

            isNew = chat.chat_items.length ? false : true
        }else{
            name = ''
            users = []
            isNew = true
        }

        let showFullName = true

        if(users.length > 2){
            showFullName = false
        }

        let usersArray = []

        users.forEach(userId => {
            const user = allUsers[userId]

            if(user){
                usersArray.push(user)
            }
        })

        let chatTitle = null

        if(chat.team_id){
            const team = allTeams[chat.team_id]

            chatTitle = team ? team.name+' chat' : 'Team chat'
        }else if(name){
            chatTitle = name
        }else{
            if (usersArray.length > 1 || (isSingle && usersArray.length == 1)) {
                usersArray.forEach((user, userIndex) => {     
                    if(!user){
                        return
                    }
                    
                    let showLastInitial = false

                    usersArray.forEach(loopedUser => {
                        if(loopedUser.id !== user.id && loopedUser.first_name === user.first_name){
                            showLastInitial = true
                        }
                    })

                    if (user.id !== userId) {
                        if (!chatTitle) {
                            chatTitle = user.first_name
                        } else {
                            if (userIndex == (users.length - 1)) {
                                chatTitle += ' & '
                            } else {
                                chatTitle += ', '
                            }

                            chatTitle += user.first_name
                        }

                        if(showFullName){
                            chatTitle += ' ' + user.last_name
                        }else if(showLastInitial){
                            chatTitle += ' '+(user.last_name.charAt(0))
                        }
                    }
                })

                if(chatTitle === 'undefined undefined'){
                    chatTitle = 'Deleted user'
                }
            } else {
                if(isNew){
                    chatTitle = 'New chat'
                }else{
                    chatTitle = "Deleted user"
                }
            }
        }

        let dotProps = null

        if(usersArray.length == 2 || (isSingle && usersArray.length == 1)){
            usersArray.forEach(user => {
                if(user.id !== userId){
                    const isOnline = onlineUsers.find(onlineUser => {
                        return user.id === onlineUser.id
                    })

                    if(isOnline){
                        dotProps = getOnlineDotProps(allUsers[user.id], isOnline)
                    }
                }
            })
        }

        return (
            <span className={dotProps ? 'dot-visible' : null} title={dotProps ? dotProps.title : null}>
                <input
                    ref="nameInput"
                    type="text"
                    value={(tempChatTitle || isNameBeingEdited) ? tempChatTitle : chatTitle}
                    placeholder={chatTitle}
                    onChange={this.updateName}
                    disabled={isNameBeingEdited ? false : true}
                    onKeyPress={e => {(e.key === 'Enter') ? this.saveChatTitle() : null }}
                />
                <em
                    className={dotProps ? dotProps.className : 'online-dot'}
                    style={dotProps ? dotProps.style : undefined}
                />
            </span>
        );
    }
}

function mapStateToProps(state){
  return {
    onlineUsers: state.account.onlineUsers,
    allUsers: state.account.entities.users,
    allTeams: state.account.entities.teams
  }
}

export default connect(mapStateToProps, null)(ChatTitle);